<script setup lang="ts">
import type { Customer } from '@/types'
import { Form } from '@inertiajs/vue3'
import { firstFormError } from '@/lib/forms'

const props = defineProps<{
  customer: Partial<Customer>
  action: string
  method: 'post' | 'patch'
  submitLabel: string
}>()
</script>

<template>
  <Form
    v-slot="{ errors, processing }"
    :action="props.action"
    :method="props.method"
    :options="{ preserveScroll: true }"
    class="max-w-2xl space-y-5"
  >
    <UFormField
      label="Name"
      name="name"
      description="The customer or organization that hosts our software."
      :error="firstFormError(errors.name)"
      required
    >
      <UInput
        id="name"
        name="name"
        :default-value="props.customer.name"
        placeholder="Acme Corp"
        icon="i-lucide-building-2"
        class="w-full"
      />
    </UFormField>

    <UFormField
      label="Notes"
      name="notes"
      description="Optional internal notes about this customer."
      :error="firstFormError(errors.notes)"
    >
      <UTextarea
        id="notes"
        name="notes"
        :default-value="props.customer.notes ?? ''"
        :rows="4"
        placeholder="Anything worth recording about this customer."
        class="w-full"
      />
    </UFormField>

    <div class="flex items-center gap-3">
      <UButton
        type="submit"
        :label="props.submitLabel"
        icon="i-lucide-save"
        :loading="processing"
      />
    </div>
  </Form>
</template>
